"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENT_AFTER_SEND_TRANSACTION = exports.EVENT_BEFORE_SEND_TRANSACTION = exports.EVENT_AFTER_SIGN_DATA = exports.EVENT_BEFORE_SIGN_DATA = exports.EVENT_LATEST_BLOCK = exports.EVENT_AFTER_DISCONNECT = exports.EVENT_BEFORE_DISCONNECT = exports.EVENT_AFTER_CONNECT = exports.EVENT_BEFORE_CONNECT = void 0;
exports.EVENT_BEFORE_CONNECT = 'web3#beforeConnect';
exports.EVENT_AFTER_CONNECT = 'web3#afterConnect';
exports.EVENT_BEFORE_DISCONNECT = 'web3#beforeDisconnect';
exports.EVENT_AFTER_DISCONNECT = 'web3#afterDisconnect';
exports.EVENT_LATEST_BLOCK = 'web3#latestBlock';
exports.EVENT_BEFORE_SIGN_DATA = 'web3#beforeSignData';
exports.EVENT_AFTER_SIGN_DATA = 'web3#afterSignData';
exports.EVENT_BEFORE_SEND_TRANSACTION = 'web3#beforeSendTransaction';
exports.EVENT_AFTER_SEND_TRANSACTION = 'web3#afterSendTransaction';
//# sourceMappingURL=events.js.map